import Swiper from "../../../../../assets/vendor/swiper/swiper-bundle.esm.browser";

export default class PartnerListSlider {
    constructor($wrapper) {
        this.$slider = $wrapper.querySelector('[data-slider]');
        this.$navigationItems = $wrapper.querySelectorAll('[data-go-to-slide]');

        this.slider = new Swiper(this.$slider, {
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 9000,
                disableOnInteraction: false
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });

        this.goToSlide = this.goToSlide.bind(this);

        this.$navigationItems.forEach($item => $item.addEventListener('click', this.goToSlide));
    }

    goToSlide(e) {
        e.preventDefault();
        const slideId =  e.target.dataset.goToSlide ?
                e.target.dataset.goToSlide:
                e.target.closest('[data-go-to-slide]').dataset.goToSlide;
        console.log( slideId);
        this.slider.slideTo(slideId);
    }
}